import axios from "axios";
import { BASE_URL } from "../../utils/urls";

export const forgotPassword = async (email) => {
  const data = JSON.stringify({
    email,
  });

  const res = await axios.post(`${BASE_URL}/forget-password`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};

export const resetPassword = async (token, password) => {
  const data = JSON.stringify({
    token,
    password,
  });

  const res = await axios.post(`${BASE_URL}/reset-password`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};

export const verifyEmail = async (token) => {
  const data = JSON.stringify({
    token,
  });

  const res = await axios.post(`${BASE_URL}/verify-email`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};
